import { ExecutePipelineDetails } from "../execute.pipeline";
import { PipelineDetailsData } from "../agent.card";
import { ErrorsOr, LogAnd } from "@me8eon/errors";
import { AssistantMessageRequest } from "@me8eon/messages";

export type AppendTextToMessagePipeline = {
    type: 'appendTextToMessage',
    textToAppend: string
}

export const appendTextToMessagePipeline = <Context>(): ExecutePipelineDetails<Context, AppendTextToMessagePipeline> => {
    return async (p: AppendTextToMessagePipeline, d): Promise<LogAnd<ErrorsOr<PipelineDetailsData<Context>>>> => {
        const { appendMessages } = d;
        const { textToAppend } = p;

        try {
            const resultMessage = appendMessages && appendMessages?.length > 0 ? appendMessages[appendMessages.length - 1] : undefined;
            if (!resultMessage) {
                return { value: d, log: "no.resultMessage" };
            }
            if (resultMessage.role !== "assistant") {
                return { value: d, log: "no.assistantMessage" };
            }
            const message = resultMessage as AssistantMessageRequest;
            if (!!message.toolCalls) {
                return { value: d, log: "is.toolCalls" };
            }
            if (!message.content) {
                return { value: d, log: "no.content" };

            }

            const last50Chars = (message.content as string).slice(-50);
            const soucesAdded = last50Chars.includes("**Source**");
            if (soucesAdded) {
                console.log("last50Chars", { last50Chars, soucesAdded });
            }

            const newContent = message.content + (soucesAdded ? "" : textToAppend);

            const newAppendMessages = [...(appendMessages || []).slice(0, -1), { ...resultMessage, content: newContent }];

            return {
                value: { ...d, appendMessages: newAppendMessages },
                log: { whatHappened: "added.textToAppend", params: textToAppend },
            };
        } catch (error) {
            return {
                value: d,
                log: { whatHappened: "error.unexpected", params: error },
            };
        }
    };
};